import { getAxiosClient } from '~src/api';

export const hideCanvas = async (canvasId) => {
  const httpClient = await getAxiosClient();

  const data = {
    status: 'hidden',
  };

  return httpClient.put(
    `${process.env.PARSE_API_URL}/editor_canvas/${canvasId}`,
    {
      data,
    }
  );
};
